export default __webpack_public_path__ + "static/media/rise.3c12737b.png";